function getQueryParam(name: string): string | null {
  const url = window.location.href;
  const serializedName = name.replace(/[\[\]]/g, "\\$&");

  const regex = new RegExp("[?&]" + serializedName + "(?:=([^&#]*))?");
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[1]) return "";
  return decodeURIComponent(results[1].replace(/\+/g, " "));
}

export { getQueryParam };
